import * as React from "react"
import {FC} from "react";

type TProps = {
    fill?: string
}
const LogoSvg: FC<TProps> = (props) => {
    return (
        <svg viewBox="0 0 115.100475 24"
             xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink"
             {...props}
        >
            <defs>
                <path
                    d="M72.376 0a7.17 7.17 0 015.3 12 7.17 7.17 0 01-5.3 12H57.903a2.358 2.358 0 110-4.715h14.473a2.455 2.455 0 100-4.91h-4.361a2.358 2.358 0 01-2.358-2.358v-.034a2.358 2.358 0 012.358-2.358h4.36a2.455 2.455 0 100-4.91H57.904a2.357 2.357 0 110-4.715h14.473zM50.829 19.29a2.331 2.331 0 012.33 2.333v.044A2.331 2.331 0 0150.828 24H37.874a2.331 2.331 0 01-2.33-2.333v-.044a2.331 2.331 0 012.33-2.334h12.955zM30.797 0c1.3 0 2.355 1.054 2.355 2.355v12.18a9.466 9.466 0 01-16.576 6.247A9.466 9.466 0 010 14.534V2.355a2.355 2.355 0 014.71 0v12.18a4.755 4.755 0 109.511 0V2.354a2.355 2.355 0 014.71 0v12.18a4.755 4.755 0 109.511 0V2.354c0-1.3 1.054-2.355 2.355-2.355zm74.838 0a9.466 9.466 0 019.465 9.466v12.179a2.355 2.355 0 01-4.71 0V9.465a4.755 4.755 0 10-9.51 0v12.18a2.355 2.355 0 01-4.71 0l-.001-12.18a4.755 4.755 0 10-9.51 0v12.18a2.355 2.355 0 01-4.71 0V9.465a9.466 9.466 0 0116.575-6.248A9.444 9.444 0 01105.634 0zM60.883 9.645a2.33 2.33 0 012.326 2.333v.044a2.33 2.33 0 01-2.326 2.333H37.87a2.33 2.33 0 01-2.326-2.333v-.044a2.33 2.33 0 012.326-2.333h23.013zM50.827 0a2.331 2.331 0 012.33 2.333v.044a2.331 2.331 0 01-2.33 2.334H37.873a2.331 2.331 0 01-2.329-2.334v-.044A2.331 2.331 0 0137.874 0h12.953z"
                    id="a"
                />
            </defs>
            <g
                transform="translate(-42.95 -67.305) translate(42.95 67.305)"
                stroke="none"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
            >
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a"/>
                </mask>
                <path
                    fill={props.fill ?? "#fff"}
                    mask="url(#b)"
                    d="M-0.75 -0.75L115.850475 -0.75 115.850475 24.75 -0.75 24.75z"
                />
            </g>
        </svg>
    )
}

export default LogoSvg
